import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';

import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from './types';

/* eslint-disable camelcase */
const ALIGN_CENTER = 'center';

export const SETTINGS_TAB = {
  SETTINGS: 'SETTINGS',
  DESIGN: 'DESIGN',
} as const;
export type SettingsTab = (typeof SETTINGS_TAB)[keyof typeof SETTINGS_TAB];

export const DEFAULT_CONFIG = {
  alignment: ALIGN_CENTER,
  size: 'small',
  width: 'fit-content',
};

export const buttonsModals = {
  settings: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonSettings`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonSettings`,
  },
  alignment: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonAlignment`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonAlignment`,
  },
  colorPicker: `${Node_Type.BUTTON}.colorPicker`,
};

export const BUTTONS_TYPE_TO_TIPTAP_ATTR = {
  [ACTION_BUTTON_TYPE]: 'ACTION',
  [LINK_BUTTON_TYPE]: 'LINK',
};
